

import classes from './Progressbar.module.css';

const ProgressBar = () => (
    <div className={classes.Loader}>Loading...</div>
);

export default ProgressBar;
